import React, { FunctionComponent, useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { Switch } from '../../../../components';
import { i18n } from '../../../../helpers/i18n';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { toggleCheckDesktopAppExistenceSettings } from '../../../settings';

const DevelopersSection: FunctionComponent = () => {
    const checkDesktopAppExistence = useTypedSelector((state) => state.settings.checkDesktopAppExistence);
    const dispatch = useDispatch();

    const onChange = useCallback(() => {
        dispatch(toggleCheckDesktopAppExistenceSettings());
    }, [dispatch]);

    return (
        <Switch
            labelBefore={i18n('settings', 'do-not-check-desktop-app-existence')}
            checked={!checkDesktopAppExistence}
            onChange={onChange}
            size="md"
            stretch
            shrink
        />
    );
};

export default DevelopersSection;
